import {getNumberFromInput} from '../../../record-editing';
import {
    LabelContainer,
    Label,
    ValidationsList,
    NumberControlShowingEdits,
    FormFieldContainer
} from '../../../components/Form/FormStyles';
import {ValidateControl} from '../../../components/Controls/ValidateControl';
import {EditedProject} from '../EditedProject';
import styled from 'styled-components';

export const NumericFormFieldContainer = styled(FormFieldContainer)`
    & > input {
        max-width: 200px;
    }
`;

export function NumberOfIndirectPeopleImpactedControl({
    project,
    setProjectAndValidate
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
}) {
    return (
        <NumericFormFieldContainer>
            <LabelContainer>
                <ValidateControl
                    validated={project.PeopleImpactedNumberValidated.current}
                    disabled={project.PeopleImpactedNumberValidated.notValidToShowPartner}
                    onChange={(e) =>
                        setProjectAndValidate({
                            ...project,
                            PeopleImpactedNumberValidated:
                                project.PeopleImpactedNumberValidated.update(e.validated)
                        })
                    }
                />
                <Label htmlFor="numberOfIndirectPeopleImpacted">
                    Number of indirectly impacted people through planting
                    {project.PeopleImpactedLandType.current &&
                        ` (${project.PeopleImpactedLandType.current})`}
                </Label>
            </LabelContainer>
            <NumberControlShowingEdits
                id="numberOfCorporateVolunteers"
                disabled
                value={project.PeopleImpactedNumber}></NumberControlShowingEdits>
        </NumericFormFieldContainer>
    );
}
